import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized-page',
  standalone: false,
  templateUrl: './unauthorized-page.component.html',
  styleUrls: ['./unauthorized-page.component.css']
})
export class UnauthorizedPageComponent {
  retrying = false;
  constructor(public auth: AuthService, private router: Router) {}
  async retry(): Promise<void> {
    this.retrying = true;
    try {
      if (await this.auth.loadStaffAccess(true)) await this.router.navigateByUrl(this.auth.landingPage());
    } finally { this.retrying = false; }
  }
}
